/* 共通ヘッダー */
import React, { memo } from 'react';
import TopHeading from './TopHeading';
import StepNavigation from './StepNavigation';
import { StepNavigation as StepType } from '../types/Template';

interface Props {
  reception_cd: string;
  status_name: string;
  label: string;
  guide_text: string;
  step_navigation?: StepType;
  display_reception_cd: boolean;
  display_status: boolean;
  is_staff?: boolean;
  suspicious_irregularity_flg?: boolean;
}

const TopArea: React.FC<Props> = ({
  reception_cd,
  status_name,
  label,
  guide_text,
  step_navigation,
  display_reception_cd,
  display_status,
  is_staff,
  suspicious_irregularity_flg,
}) => {
  return (
    <>
      <TopHeading label={label} />
      <div
        className={`top-area-step-navigation ${!step_navigation?.show && 'step-navigation-hidden'}`}
      >
        {step_navigation && step_navigation.show && (
          <StepNavigation
            step1={step_navigation.step1 ? step_navigation.step1 : ''}
            step2={step_navigation.step2 ? step_navigation.step2 : ''}
            step3={step_navigation.step3 ? step_navigation.step3 : ''}
            step4={step_navigation.step4 ? step_navigation.step4 : ''}
            current={step_navigation.current}
            disabled={false}
          />
        )}
      </div>
      <div
        className={`
        top-area-reception-status
        ${!display_status ? 'top-area-status-hidden' : ''}
      `}
      >
        <>
          {/* 不正取引アラート */}
          {is_staff && suspicious_irregularity_flg && (
            <div className="reception-alert">
              <p className="label">アラート</p>
              <p className="value text-danger">不正取引の疑い</p>
            </div>
          )}
          {/* 案件番号 */}
          {display_reception_cd && (
            <div className="reception-code">
              <p className="label">案件番号</p>
              <p className="value">{reception_cd}</p>
            </div>
          )}
          {/* 案件ステータス */}
          <div className="reception-status">
            <p className="label">案件ステータス</p>
            <p className="value">{status_name}</p>
          </div>
        </>
      </div>
      {guide_text && (
        <div className="top-area-guidtext">
          <p>{guide_text}</p>
        </div>
      )}
    </>
  );
};

export default memo(TopArea);
